/**
 * TermsOfServicePage component
 * Requirements: 10.3 - Display terms of service
 */
import {
  Container,
  Typography,
  Paper,
  Box,
  Divider,
} from '@mui/material';

interface TermsSection {
  title: string;
  content: React.ReactNode;
}

const termsSections: TermsSection[] = [
  {
    title: 'サービスの概要',
    content: (
      <Typography variant="body2">
        本サービスは、ユーザーの回答から思考傾向を分析し、可視化するWebアプリケーションです。
        本サービスを利用することにより、本利用規約に同意したものとみなされます。
      </Typography>
    ),
  },
  {
    title: 'ユーザーの責任',
    content: (
      <Box component="ul" sx={{ mt: 0 }}>
        <li>
          <Typography variant="body2">
            正確な情報を登録すること
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            アカウント情報を安全に管理すること
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            他のユーザーのプライバシーを尊重すること
          </Typography>
        </li>
      </Box>
    ),
  },
  {
    title: '禁止事項',
    content: (
      <Box component="ul" sx={{ mt: 0 }}>
        <li>
          <Typography variant="body2">
            不正アクセスや不正行為
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            他のユーザーへのなりすまし
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            サービスの運営を妨害する行為
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            法令に違反する行為
          </Typography>
        </li>
      </Box>
    ),
  },
  {
    title: 'サービスの提供',
    content: (
      <Typography variant="body2">
        本サービスは「現状有姿」で提供されます。
        メンテナンスや緊急時にはサービスを一時停止する場合があります。
      </Typography>
    ),
  },
  {
    title: '知的財産権',
    content: (
      <Typography variant="body2">
        本サービスに関する著作権、商標権、その他の知的財産権は当社に帰属します。
        ユーザーが入力したデータの所有権はユーザーに帰属します。
      </Typography>
    ),
  },
  {
    title: '免責事項',
    content: (
      <Typography variant="body2">
        本サービスの利用によって生じた損害について、当社は法律で許容される範囲内で責任を負いません。
        分析結果はあくまで参考情報であり、専門的な判断の代替とはなりません。
      </Typography>
    ),
  },
  {
    title: '規約の変更',
    content: (
      <Typography variant="body2">
        本規約は予告なく変更される場合があります。
        重要な変更がある場合は、サービス内で通知します。
      </Typography>
    ),
  },
];

export const TermsOfServicePage = () => {
  const lastUpdated = '2024年1月1日';

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          利用規約
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          最終更新日: {lastUpdated}
        </Typography>

        <Divider sx={{ mb: 3 }} />

        {termsSections.map((section, index) => (
          <Box key={section.title} sx={{ mb: index < termsSections.length - 1 ? 3 : 0 }}>
            <Typography variant="h6" gutterBottom>
              {section.title}
            </Typography>
            {section.content}
          </Box>
        ))}
      </Paper>
    </Container>
  );
};
